import { css } from '@emotion/react';
import { Stack } from '~/_shared/baseComponents/layout/stack.component';
import { ImageComponent } from '~/_shared/components/image/image.component';
import { ImageSelectorComponent } from '~/_shared/components/imageSelector/imageSelector.component';
import { useTranslation } from '~/_shared/utils/hooks';
import { notNullsy } from '~/_shared/utils/typeGuards';
import {
  type MapTemplates, mapTemplates,
} from './mapTemplates.helpers';

export const IMAGE_PADDING = 16;
export const IMAGE_WIDTH = 236;

const imageHolderStyle = css({
  boxSizing: 'border-box',
  height: '100%',
  padding: IMAGE_PADDING,
  position: 'relative',
  width: '100%',
});

const titleStyle = css({
  fontSize: 16,
});

const descriptionStyle = css({
  fontSize: 12,
  fontWeight: 300,
});

type MapTemplatesComponentProps = {
  onTemplateSelected: (template: MapTemplates) => void;
};

export const MapTemplatesComponent = ({ onTemplateSelected }: MapTemplatesComponentProps) => {
  const [t] = useTranslation();

  const handleSelectionChanged = (selectedTemplates: ReadonlyArray<MapTemplates>) => {
    const selected = selectedTemplates[0];
    if (notNullsy(selected)) {
      onTemplateSelected(selected);
    }
  };

  const mapStylesImages = mapTemplates.map(thumbnail => ({
    id: thumbnail.id,
    render: () => (
      <Stack
        css={imageHolderStyle}
        data-testid={`map-template-${thumbnail.id}`}
        gap={8}
        key={thumbnail.id}
      >
        <ImageComponent
          src={thumbnail.url}
        />
        <Stack gap={6}>
          <div css={titleStyle}>{t(`MapTemplates.${thumbnail.id}.title`)}</div>
          <div css={descriptionStyle}>{t(`MapTemplates.${thumbnail.id}.description`)}</div>
        </Stack>
      </Stack>
    ),
  }));

  return (
    <>
      <ImageSelectorComponent
        imageHeight={251}
        imageWidth={IMAGE_WIDTH}
        images={mapStylesImages}
        multiselect={false}
        onSelectionChanged={handleSelectionChanged}
        paddingHorizontal={IMAGE_PADDING}
        paddingVertical={IMAGE_PADDING}
        selectedImagesIds={[]}
      />
    </>
  );
};
